import PropTypes from 'prop-types';
import ConnectionsBox from './box/connectionsBox';
import hasConnections from '../../../utils/connections/hasConnections';
import { connectionsPropTypes } from '../../../utils/connections/connectionType';

export default function ConnectionsPanel({ connections }) {
  if (!hasConnections(connections)) {
    return null;
  }
  return (
    <div className="connections-panel u-padding-s-bottom">
      <h3 className="u-padding-xs-bottom text-m">Connections</h3>
      <ConnectionsBox connections={connections} />
    </div>
  );
}

ConnectionsPanel.propTypes = {
  connections: PropTypes.shape(connectionsPropTypes),
};

ConnectionsPanel.defaultProps = {
  connections: {},
};
